module.exports = __webpack_public_path__ + "img/used.c2d93e1a.png";